import { useFeatureFlagEnabled } from "@posthog/react";

import {
  SidebarContent,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarMenuSub,
} from "../ui/sidebar";
import { getSidebarNavigation } from "./data";
import { SidebarItem } from "./item";

export function AppSidebarContent() {
  const isIntegrationsFlagEnabled = useFeatureFlagEnabled(
    "integrations-page",
  );

  const sidebarNavigation = getSidebarNavigation(
    (flag) => flag === "integrations-page" && !!isIntegrationsFlagEnabled,
  );

  return (
    <SidebarContent className="bg-background">
      <SidebarGroup>
        <SidebarMenu className="gap-2">
          {sidebarNavigation.map(({ title, url, items }) => {
            return (
              <SidebarMenuItem key={title}>
                <SidebarMenuButton className="pointer-events-none" asChild>
                  <a
                    href={url}
                    className="text-[11px] font-bold text-muted-foreground"
                  >
                    {title}
                  </a>
                </SidebarMenuButton>

                <SidebarMenuSub className="ml-0 border-l-0 px-1.5">
                  {items.map((item) => (
                    <SidebarItem key={item.title} {...item} />
                  ))}
                </SidebarMenuSub>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroup>
    </SidebarContent>
  );
}
